import cn from "classnames"
import React from "react"
import { connect } from "react-redux"
import AutoGrid from "@/signomatic/components/auto_grid"
import { type ToolboxStripItemProps } from "@/signomatic/components/toolbox_strip"
import { type State } from "@/signomatic/store/reducers"

interface PatternProps {
  name: string
  disabledReason: string
  enabled: boolean
  active: boolean
  update: () => void
}

const Pattern = ({ name, active, update }: PatternProps) => (
  <div className={cn("pattern-button", name, { active })} onClick={update}>
    <div className="pattern-wrapper">
      <div className="pattern-background"></div>
      <div className="pattern" />
    </div>
  </div>
)

interface PatternToolboxStateProps {
  data: SignData
  signState: SignState
}

type PatternToolboxProps = PatternToolboxStateProps & ToolboxStripItemProps

const PatternToolbox: React.FC<PatternToolboxProps> = ({ sign, signState, data }) => {
  return (
    <div className="pattern-toolbox">
      <AutoGrid>
        {data.patterns.map(pattern => {
          const active = signState.pattern === pattern.name

          return (
            <Pattern
              key={pattern.name}
              name={pattern.name}
              active={active}
              enabled={pattern.enabled || false}
              disabledReason={(pattern.disabled_reason && pattern.disabled_reason[0]) || ""}
              update={() => {
                if (!pattern.enabled) {
                  return
                }

                sign.updateState({ pattern: pattern.name })
              }}
            />
          )
        })}
      </AutoGrid>
    </div>
  )
}

export default connect(
  ({ signState, currentSignData }: State) => ({
    signState,
    data: currentSignData,
  }),
  {}
)(PatternToolbox)
